function languageData() {
  return {
    instructions: "Instructions",
    language: "Language",
    nav: {
      p0: "Services",
      p1: "The Team",
      p2: "Blog",
      p3: "Contacts",
      p4: "Tools",
      p5: "GET FREE CONSULTATION",
    },
    greeting: "Welcome! Please enter the access code",
    enter: "Enter access code",
    get: "I do not have a code",
    mail: "Subscribe and get code",
    back: "Back",
    again: "Try subscription again",
    incorrect: "The code is incorrect, please try again",
    subscribe:
      "Subscribe to my newsletter to get access to the code and receive the latest marketing insights (can be undone at any time)",
    mailsent:
      "Successfully registered! Please check your e-mail and enter the access code received",
    placeholder1: "Please enter the code",
    placeholder2: "Please enter your email",
    wrongCode: "The code entered is incorrect",
    wrongEmail: "The email entered is invalid.",
    privacyAgree: "By checking this box you agree to our",
    privacyAgree2: "privacy policy",
    notAgreed: "Please agree to the privacy policy in order to subscribe",
    notSupported:
      "It seems your browser does not support some of the features used here and they may not function properly. For a better experience, it is recommended to update your browser.",
    close: "close",
    facebookAdsCalculator: {
      title: "Facebook Ads Budget Calculator",
      typeplaceholder: "Type here",
      disclaimer: {
        p0:
          "Allow at least 1x AOV spend before you start optimizing your ad account.",
        p1:
          "In this calculator, the budget is also changed according to the analysis frequency and optimization. The more is spent, the faster the results can be obtained for optimization. The less is spent, the slower the optimization.",
        p2:
          "Another important factor (which I do not consider in this calculator because it is more specific) is the audience size.",
        p3:
          "Using too much budget in a given audience can mean a higher frequency and an increase in the long-term costs due to saturation.",
      },
      warning: "Warning: the sum of the percentages below is ",
      col1: { p1: "Benchmarks", p2: "in", p3: "Analysis Frequency", p4: "AOV" },
      col2: { p1: "Daily", p2: "Monthly" },
      tooltips: {
        p0: "Change the green numbers to obtain the budget.",
        p1:
          'TOF - Top of funnel, is the top of the conversion/marketing funnel, in this section of the funnel we want to show ads to people who have never heard of us and never seen an ad from us. To this audience we usually call "Cold Audience".',
        p2:
          'MOF - Middle-of-funnel is the middle part of the conversion/marketing funnel, in this section of the funnel we want to show ads to people who have seen an ad from us and have interacted with it. These people have already shown some interest for our product or service but have not yet decided to proceed with the purchase. To this audience we usually call "Warm Audience".',
        p3:
          'BOF - Bottom-of-funnel is the bottom part of the conversion/marketing funnel, in this section of the funnel we want to show ads to people who have already seen an ad from us, entered our site and have performed some valuable interaction such as viewing a product page, adding a product to the cart or even starting the checkout but have not converted yet. To this audience we usually call "Hot Audience".',
        p4:
          "AOV - Average Order Value, is the average value of your sales in the online store, you can calculate this value by dividing the total revenue by the number of sales in a certain period of time.",
        p5: "Examples of frequency:",
        p6: "1 - Every day",
        p7: "2 - Every 2 days",
        p8: "3 - Every 3 days",
        p9: "X - Every X days",
      },
    },
  };
}

export default languageData;
